import { ItemCategory } from '../types';

export enum OrderType {
	SearchResults = 'Results',
	Checkout = 'Checkout',
	Checkin = 'Checkin'
}

export interface DataLayerService {
	category: ItemCategory;
	name: string;
	price: number;
	segmentId?: string;
	travellersTypes?: string[];

	/**
	 * Service will be sent by a single item.
	 */
	segmentIds?: string[];
	isRecommend?: boolean;
	item_list_name?: string;
	count?: number;

	/**
	 * Separate service for each segment in the order
	 */
	forAllSegments?: boolean;
}
